module.exports = __webpack_public_path__ + "static/media/nkjv.58d37a81.jpg";